import styled from 'styled-components';

/** Full-bleed canvas the monochrome dot field renders into (fills its positioned
 *  parent). */
export const Canvas = styled.canvas`
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
`;
